export const TASK_TYPES = {
  ball_supertrack: "ball_supertrack",
  track: "track",
  event: "event",
  supertrack: "supertrack",
  validate: "validate",
  match_event: "match_event",
  event_tagging: "event_tagging",
};

export const taskTypes = [
  "ball_supertrack",
  "supertrack",
  "validate",
  "match_event",
  "event_tagging",
];

export const taskTypeOptions = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Ball Markup",
    value: "ball_supertrack",
  },
  {
    label: "Supertrack",
    value: "supertrack",
  },
  {
    label: "Validate",
    value: "validate",
  },
  {
    label: "Match Event",
    value: "match_event",
  },
  {
    label: "Tagging",
    value: "event_tagging",
  },
];

export const internTaskOptions = [];

export const timePeriods = [
  {
    label: "Day",
    value: "day",
  },
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Month",
    value: "month",
  },
];
